
// import React from "react";
// import { motion } from "framer-motion";
// import {
//   FaCogs,
//   FaLaptopCode,
//   FaBullhorn,
//   FaIndustry,
//   FaProjectDiagram,
//   FaUsers,
// } from "react-icons/fa";
// import yourImage from "../img/aaaservices/n.webp";

// const cardData = [
//   {
//     id: 1,
//     title: "End-to-End IT Solutions",
//     text: "From software development to cloud integration, we deliver scalable IT systems.",
//     icon: <FaLaptopCode size={32} color="#fff" />,
//     bg: "#60a5fa",
//     direction: { x: -100, y: 0 },
//   },
//   {
//     id: 2,
//     title: "Mechanical Design & Automation",
//     text: "Advanced CAD/CAM, prototyping, and automation for industrial innovation.",
//     icon: <FaCogs size={32} color="#fff" />,
//     bg: "#34d399",
//     direction: { x: 100, y: 0 },
//   },
//   {
//     id: 3,
//     title: "Digital Marketing Expertise",
//     text: "Data-driven campaigns to boost your online presence and customer reach.",
//     icon: <FaBullhorn size={32} color="#fff" />,
//     bg: "#f87171",
//     direction: { x: 0, y: 100 },
//   },
//   {
//     id: 4,
//     title: "Industry-Aligned Strategies",
//     text: "Custom solutions tailored to your sector's specific requirements.",
//     icon: <FaIndustry size={32} color="#fff" />,
//     bg: "#c084fc",
//     direction: { x: 0, y: -100 },
//   },
//   {
//     id: 5,
//     title: "Proven Project Experience",
//     text: "Successful delivery across IT, manufacturing, and marketing projects.",
//     icon: <FaProjectDiagram size={32} color="#fff" />,
//     bg: "#fbbf24",
//     direction: { x: -100, y: 0 },
//   },
//   {
//     id: 6,
//     title: "Collaborative Partnerships",
//     text: "Working closely with you to ensure innovation meets your goals.",
//     icon: <FaUsers size={32} color="#fff" />,
//     bg: "#38bdf8",
//     direction: { x: 100, y: 0 },
//   },
// ];

// const WhyChooseUs = () => {
//   return (
//     <div style={styles.container}>
//       {/* ✅ Responsive styles injected */}
//       <style>{`
//         .cardsContainer {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr); /* desktop default */
//           gap: 20px;
//         }

//         @media (max-width: 1024px) {
//           .cardsContainer {
//             grid-template-columns: repeat(2, 1fr); /* tablet */
//           }
//         }

//         @media (max-width: 768px) {
//           .innerContainer {
//             flex-direction: column;
//             gap: 20px;
//             align-items: center;
//           }
//           .left {
//             order: 1; /* image on top */
//             max-width: 100%;
//           }
//           .right {
//             order: 2; /* cards below */
//             width: 100%;
//           }
//           .cardsContainer {
//             grid-template-columns: 1fr;
//             width: 100%;
            
//           }
//           .heading {
//             margin-top: 5px;
//             padding-right: 20px;
//             padding-left: 20px;
//             text-align: justify;
//             font-size: 22px;
             
//           }
//           p {
//             font-size: 18px;
//             padding: 0 15px;
//             line-height: 1.4;
//           }
//         }

//         @media (max-width: 480px) {
//           .tag {
//             font-size: 24px !important;
//             margin-right: 0 !important;
//             padding: 0 10px;
//             text-align: center;
             
//           }
//           .cardsContainer {
//             gap: 15px;
//           }
//           .cardTitle {
//             font-size: 16px !important;
//           }
//           .cardText {
//             font-size: 13px !important;
//             padding: 0 10px;
//           }
//           .icon {
//             width: 50px !important;
//             height: 50px !important;
//           }
//             .image{
//             padding-top:-20px;
//             }
//         }
//       `}</style>

//       <div style={styles.wrapper}>
//         <p className="tag" style={styles.tag}>
//           <span style={{ color: "#ffffff" }}>Why </span>
//           <span style={{ color: "#FACC15" }}>Choose Us</span>
//         </p>

//         <div className="innerContainer" style={styles.innerContainer}>
//           {/* LEFT IMAGE */}
//           <div className="left" style={styles.left}>
//             <div style={styles.imageWrapper}>
//               <img src={yourImage} alt="why choose us" style={styles.image} />
//             </div>
//           </div>

//           {/* RIGHT CARDS */}
//           <div className="right" style={styles.right}>
//             <div className="cardsContainer">
//               {cardData.map((card, index) => (
//                 <motion.div
//                   key={card.id}
//                   initial={{ ...card.direction, opacity: 0 }}
//                   whileInView={{ x: 0, y: 0, opacity: 1 }}
//                   transition={{ duration: 0.8, delay: index * 0.2 }}
//                   viewport={{ once: true }}
//                   style={{ ...styles.card, backgroundColor: card.bg }}
//                 >
//                   <div className="icon" style={styles.icon}>{card.icon}</div>
//                   <h4 className="cardTitle" style={styles.cardTitle}>{card.title}</h4>
//                   <p className="cardText" style={styles.cardText}>{card.text}</p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     backgroundColor: "rgba(14, 127, 157, 0.5)",
//     padding: "50px 20px",
//     display: "flex",
//     justifyContent: "center",
//     width: "100%",
//     boxSizing: "border-box",
//   },
//   wrapper: {
//     width: "100%",
//     maxWidth: "1200px",
//   },
//   innerContainer: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "40px",
//     alignItems: "center",
//     justifyContent: "center",
//     width: "100%",
//   },
//   left: {
//     flex: "1 1 400px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     minWidth: "300px",
//   },
//   imageWrapper: {
//     width: "100%",
//     maxWidth: "420px",
//     borderRadius: "18px",
//     overflow: "hidden",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//     marginTop: "50px",
//   },
//   image: {
//     width: "100%",
//     height: "auto",
//     display: "block",
//     objectFit: "cover",
//   },
//   right: {
//     flex: "1 1 600px",
//     display: "flex",
//     flexDirection: "column",
//     minWidth: "300px",
//   },
//   tag: {
//     fontSize: "clamp(28px, 5vw, 40px)",
//     fontWeight: "bold",
//     marginBottom: "30px",
//     textAlign: "center",
//     marginRight: "-150px",
//   },
//   heading: {
//     fontSize: "32px",
//     fontWeight: "bold",
//     marginBottom: "30px",
//     textAlign: "center",
//     lineHeight: "1.3",
//     letterSpacing: "0px",
//   },
//   card: {
//     borderRadius: "12px",
//     padding: "18px 16px",
//     boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
//     color: "#fff",
//     textAlign: "center",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     minHeight: "150px",
//     transition: "transform 0.3s ease",
//   },
//   icon: {
//     marginBottom: "12px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "60px",
//     height: "60px",
//     borderRadius: "50%",
//     backgroundColor: "rgba(255, 255, 255, 0.2)",
//   },
//   cardTitle: {
//     fontSize: "17px",
//     fontWeight: "600",
//     marginBottom: "10px",
//     color: "#fff",
//     lineHeight: "1.3",
//     letterSpacing: "0px",
//   },
//   cardText: {
//     fontSize: "14px",
//     lineHeight: "1.5",
//   },
// };

// export default WhyChooseUs;


// import React from "react";
// import {
//   FaCogs,
//   FaLaptopCode,
//   FaBullhorn,
//   FaIndustry,
//   FaProjectDiagram,
//   FaUsers,
// } from "react-icons/fa";
// import yourVideo from "./robotics hands workingVideo.mp4";


// const cardData = [
//   {
//     id: 1,
//     title: "End-to-End IT Solutions",
//     text: "From software development to cloud integration, we deliver scalable IT systems.",
//     icon: <FaLaptopCode size={32} color="#fff" />,
//     bg: "#60a5fa",
//   },
//   {
//     id: 2,
//     title: "Mechanical Design & Automation",
//     text: "Advanced CAD/CAM, prototyping, and automation for industrial innovation.",
//     icon: <FaCogs size={32} color="#fff" />,
//     bg: "#34d399",
//   },
//   {
//     id: 3,
//     title: "Digital Marketing Expertise",
//     text: "Data-driven campaigns to boost your online presence and customer reach.",
//     icon: <FaBullhorn size={32} color="#fff" />,
//     bg: "#f87171",
//   },
//   {
//     id: 4,
//     title: "Industry-Aligned Strategies",
//     text: "Custom solutions tailored to your sector's specific requirements.",
//     icon: <FaIndustry size={32} color="#fff" />,
//     bg: "#c084fc",
//   },
//   {
//     id: 5,
//     title: "Proven Project Experience",
//     text: "Successful delivery across IT, manufacturing, and marketing projects.",
//     icon: <FaProjectDiagram size={32} color="#fff" />,
//     bg: "#fbbf24",
//   },
//   {
//     id: 6,
//     title: "Collaborative Partnerships",
//     text: "Working closely with you to ensure innovation meets your goals.",
//     icon: <FaUsers size={32} color="#fff" />,
//     bg: "#38bdf8",
//   },
// ];

// const WhyChooseUs = () => {
//   return (
//     <div className="why-choose-us-container">
//       <div className="why-choose-us-wrapper">
//         <div className="why-choose-us-header">
//           <h2 className="why-choose-us-title">
//             <span className="why-choose-us-title-white">Why </span>
//             <span className="why-choose-us-title-accent">Choose Us</span>
//           </h2>
//           <p className="why-choose-us-subtitle">
//             We deliver excellence through innovation, expertise, and a commitment to your success.
//           </p>
//         </div>

//         <div className="why-choose-us-content">
//           {/* LEFT IMAGE SECTION */}
//           <div className="why-choose-us-image-section">
//             <div className="why-choose-us-image-wrapper">
//               <video
//   src={yourVideo}
//   className="why-choose-us-image"
//   autoPlay
//   loop
//   muted
//   playsInline
//   preload="metadata"
// >
//   Your browser does not support the video tag.
// </video>

//               <div className="why-choose-us-image-overlay">
//                 <div className="why-choose-us-experience-badge">
//                   <span className="experience-number">15+</span>
//                   <span className="experience-text">Years Experience</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT CARDS SECTION */}
//           <div className="why-choose-us-cards-section">
//             <div className="why-choose-us-grid">
//               {cardData.map((card) => (
//                 <div 
//                   key={card.id} 
//                   className="why-choose-us-card"
//                   style={{ backgroundColor: card.bg }}
//                 >
//                   <div className="why-choose-us-card-icon">
//                     {card.icon}
//                   </div>
//                   <div className="why-choose-us-card-content">
//                     <h3 className="why-choose-us-card-title">{card.title}</h3>
//                     <p className="why-choose-us-card-text">{card.text}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .why-choose-us-container {
//           // background: linear-gradient(135deg, rgba(14, 127, 157, 0.9) 0%, rgba(14, 127, 157, 0.7) 100%);
//           padding: 80px 20px;
//           width: 100%;
//           position: relative;
//           overflow: hidden;
//         }

//         .why-choose-us-wrapper {
//           max-width: 1200px;
//           margin: 0 auto;
//           position: relative;
//         }

//         .why-choose-us-header {
//           text-align: center;
//           margin-bottom: 60px;
//         }

//         .why-choose-us-title {
//           font-size: 3.5rem;
//           font-weight: 800;
//           margin-bottom: 20px;
//           line-height: 1.2;
//           letter-spacing: -0.5px;
//         }

//         .why-choose-us-title-white {
//           color: #ffffff;
//         }

//         .why-choose-us-title-accent {
//           color: #FACC15;
//         }

//         .why-choose-us-subtitle {
//           font-size: 1.25rem;
//           color: rgba(255, 255, 255, 0.9);
//           max-width: 600px;
//           margin: 0 auto;
//           line-height: 1.6;
//         }

//         .why-choose-us-content {
//           display: flex;
//           gap: 60px;
//           align-items: flex-start;
//         }

//         .why-choose-us-image-section {
//           flex: 1;
//           position: relative;
//         }

//         .why-choose-us-image-wrapper {
//           position: relative;
//           border-radius: 20px;
//           overflow: hidden;
//           box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
//           transform: perspective(1000px) rotateY(-5deg);
//           transition: transform 0.3s ease;
//         }

//         .why-choose-us-image-wrapper:hover {
//           transform: perspective(1000px) rotateY(0deg);
//         }

//         .why-choose-us-image {
//   width: 100%;
//   height: 700px;
//   object-fit: cover; /* just like image */
//   border-radius: 12px; /* optional */
// }


//         .why-choose-us-image-overlay {
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
//           padding: 30px;
//         }

//         .why-choose-us-experience-badge {
//           background: rgba(250, 204, 21, 0.95);
//           color: #000;
//           padding: 15px 25px;
//           border-radius: 12px;
//           display: inline-flex;
//           flex-direction: column;
//           align-items: center;
//           box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
//         }

//         .experience-number {
//           font-size: 2.5rem;
//           font-weight: 800;
//           line-height: 1;
//         }

//         .experience-text {
//           font-size: 1rem;
//           font-weight: 600;
//           margin-top: 5px;
//           text-align: center;
//         }

//         .why-choose-us-cards-section {
//           flex: 1;
//           width: 100%;
//         }

//         .why-choose-us-grid {
//           display: flex;
//           flex-direction: column;
//           gap: 15px;
//           width: 100%;
//         }

//         .why-choose-us-card {
//           border-radius: 12px;
//           padding: 20px;
//           color: white;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//           transition: all 0.3s ease;
//           display: flex;
//           align-items: center;
//           text-align: left;
//           position: relative;
//           overflow: hidden;
//           min-height: auto;
//           width: 100%;
//           border-left: 4px solid rgba(255, 255, 255, 0.3);
//         }

//         .why-choose-us-card:hover {
//           transform: translateX(5px);
//           box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
//         }

//         .why-choose-us-card-icon {
//           width: 60px;
//           height: 60px;
//           min-width: 60px;
//           border-radius: 12px;
//           // background: rgba(255, 255, 255, 0.2);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-right: 20px;
//           backdrop-filter: blur(5px);
//         }

//         .why-choose-us-card-content {
//           flex: 1;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//         }

//         .why-choose-us-card-title {
//           font-size: 1.1rem;
//           font-weight: 700;
//           margin-bottom: 8px;
//           line-height: 1.3;
//         }

//         .why-choose-us-card-text {
//           font-size: 0.9rem;
//           line-height: 1.5;
//           opacity: 0.95;
//           margin: 0;
//         }

//         /* Tablet Styles */
//         @media (max-width: 1024px) {
//           .why-choose-us-content {
//             flex-direction: column;
//             gap: 50px;
//           }

//           .why-choose-us-image-section,
//           .why-choose-us-cards-section {
//             width: 100%;
//             max-width: 800px;
//             margin: 0 auto;
//           }

//           .why-choose-us-image-wrapper {
//             transform: none;
//             max-width: 600px;
//             margin: 0 auto;
//           }

//           .why-choose-us-image-wrapper:hover {
//             transform: none;
//           }

//           .why-choose-us-grid {
//             display: grid;
//             grid-template-columns: repeat(2, 1fr);
//             gap: 20px;
//           }

//           .why-choose-us-card {
//             flex-direction: column;
//             text-align: center;
//             padding: 25px 20px;
//             min-height: 220px;
//           }

//           .why-choose-us-card-icon {
//             margin-right: 0;
//             margin-bottom: 20px;
//           }
//         }

//         /* Small Tablet Styles */
//         @media (max-width: 768px) {
//           .why-choose-us-container {
//             padding: 60px 15px;
//           }

//           .why-choose-us-title {
//             font-size: 2.75rem;
//           }

//           .why-choose-us-subtitle {
//             font-size: 1.1rem;
//             padding: 0 15px;
//           }

//           .why-choose-us-grid {
//             grid-template-columns: 1fr;
//             gap: 15px;
//           }

//           .why-choose-us-card {
//             padding: 20px;
//             min-height: auto;
//             flex-direction: row;
//             text-align: left;
//           }

//           .why-choose-us-card-icon {
//             margin-right: 20px;
//             margin-bottom: 0;
//           }
//         }

//         /* Mobile Styles */
//         @media (max-width: 480px) {
//           .why-choose-us-container {
//             padding: 40px 10px;
//           }

//           .why-choose-us-title {
//             font-size: 2.25rem;
//             margin-bottom: 15px;
//           }

//           .why-choose-us-subtitle {
//             font-size: 1rem;
//             padding: 0 10px;
//           }

//           .why-choose-us-header {
//             margin-bottom: 40px;
//           }

//           .why-choose-us-image {
//             min-height: 350px;
//           }

//           .why-choose-us-experience-badge {
//             padding: 12px 20px;
//           }

//           .experience-number {
//             font-size: 2rem;
//           }

//           .experience-text {
//             font-size: 0.9rem;
//           }

//           .why-choose-us-card {
//             padding: 18px 15px;
//             flex-direction: column;
//             text-align: center;
//           }

//           .why-choose-us-card-icon {
//             width: 55px;
//             height: 55px;
//             margin-right: 0;
//             margin-bottom: 15px;
//           }

//           .why-choose-us-card-title {
//             font-size: 1rem;
//           }

//           .why-choose-us-card-text {
//             font-size: 0.85rem;
//           }
//         }

//         /* Small Mobile Styles */
//         @media (max-width: 360px) {
//           .why-choose-us-title {
//             font-size: 2rem;
//           }

//           .why-choose-us-subtitle {
//             font-size: 0.9rem;
//           }

//           .why-choose-us-card {
//             padding: 15px 12px;
//           }

//           .why-choose-us-card-icon {
//             width: 50px;
//             height: 50px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };
//  export default WhyChooseUs;




import React from "react";
import {
  FaCogs,
  FaLaptopCode,
  FaBullhorn,
  FaIndustry,
  FaProjectDiagram,
  FaUsers,
} from "react-icons/fa";
import yourVideo from "./robotics hands workingVideo.mp4";

const cardData = [
  {
    id: 1,
    title: "End-to-End IT Solutions",
    text: "From software development to cloud integration, we deliver scalable IT systems.",
    icon: <FaLaptopCode size={18} color="#fff" />,
    bg: "#60a5fa",
  },
  {
    id: 2,
    title: "Mechanical Design & Automation",
    text: "Advanced CAD/CAM, prototyping, and automation for industrial innovation.",
    icon: <FaCogs size={18} color="#fff" />,
    bg: "#34d399",
  },
  {
    id: 3,
    title: "Digital Marketing Expertise",
    text: "Data-driven campaigns to boost your online presence and customer reach.",
    icon: <FaBullhorn size={18} color="#fff" />,
    bg: "#f87171",
  },
  {
    id: 4,
    title: "Industry-Aligned Strategies",
    text: "Custom solutions tailored to your sector's specific requirements.",
    icon: <FaIndustry size={18} color="#fff" />,
    bg: "#c084fc",
  },
  {
    id: 5,
    title: "Proven Project Experience",
    text: "Successful delivery across IT, manufacturing, and marketing projects.",
    icon: <FaProjectDiagram size={18} color="#fff" />,
    bg: "#fbbf24",
  },
  {
    id: 6,
    title: "Collaborative Partnerships",
    text: "Working closely with you to ensure innovation meets your goals.",
    icon: <FaUsers size={18} color="#fff" />,
    bg: "#38bdf8",
  },
];

const WhyChooseUs = () => {
  return (
    <div className="why-choose-us-container">
      <div className="why-choose-us-wrapper">
        <div className="why-choose-us-header">
          <h2 className="why-choose-us-title">
            <span className="why-choose-us-title-white">Why </span>
            <span className="why-choose-us-title-accent">Choose Us</span>
          </h2>
          <p className="why-choose-us-subtitle">
            We deliver excellence through innovation, expertise, and a commitment to your success.
          </p>
        </div>

        <div className="why-choose-us-content">
          {/* LEFT VIDEO SECTION */}
          <div className="why-choose-us-image-section">
            <div className="why-choose-us-image-wrapper">
              <video
                src={yourVideo}
                className="why-choose-us-image"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
              >
                Your browser does not support the video tag.
              </video>

              {/* subtle frame accents for a premium look */}
              <span className="why-choose-us-frame-corner corner-tl" aria-hidden="true" />
              <span className="why-choose-us-frame-corner corner-br" aria-hidden="true" />

              <div className="why-choose-us-experience-badge">
                <span className="experience-number">15+</span>
                <span className="experience-text">Years Experience</span>
              </div>
            </div>
          </div>

          {/* RIGHT CARDS SECTION */}
          <div className="why-choose-us-cards-section">
            <div className="why-choose-us-grid">
              {cardData.map((card) => (
                <div
                  key={card.id}
                  className="why-choose-us-card"
                  style={{ backgroundColor: card.bg }}
                >
                  <div className="why-choose-us-card-icon">
                    {card.icon}
                  </div>
                  <div className="why-choose-us-card-content">
                    <h3 className="why-choose-us-card-title">{card.title}</h3>
                    <p className="why-choose-us-card-text">{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .why-choose-us-container {
  padding: 9px 20px;
  background-image: url("/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  position: relative;
  overflow: hidden;
}

        .why-choose-us-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
        }

        .why-choose-us-header {
          text-align: center;
          margin-bottom: 36px;
        }

        .why-choose-us-title {
          font-size: 2.6rem;
          font-weight: 800;
          margin-bottom: 12px;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .why-choose-us-title-white {
          color: #ffffff;
        }

        .why-choose-us-title-accent {
          color: #facc15;
        }

        .why-choose-us-subtitle {
          font-size: 1.05rem;
          color: rgba(255, 255, 255, 0.85);
          max-width: 560px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .why-choose-us-content {
          display: flex;
          gap: 36px;
          align-items: stretch;
        }

        /* ================= Left: video frame ================= */
        .why-choose-us-image-section {
          flex: 1;
          position: relative;
        }

        .why-choose-us-image-wrapper {
          position: relative;
          height: 100%;
          min-height: 380px;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 20px 45px -14px rgba(0, 0, 0, 0.45);
          border: 1px solid rgba(255, 255, 255, 0.12);
          background: #0b1620;
        }

        .why-choose-us-image {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* Thin gold corner accents — a quiet "premium" signature instead of a heavy tilt/overlay */
        .why-choose-us-frame-corner {
          position: absolute;
          width: 34px;
          height: 34px;
          pointer-events: none;
          z-index: 2;
        }

        .corner-tl {
          top: 14px;
          left: 14px;
          border-top: 2px solid rgba(250, 204, 21, 0.85);
          border-left: 2px solid rgba(250, 204, 21, 0.85);
          border-radius: 4px 0 0 0;
        }

        .corner-br {
          bottom: 14px;
          right: 14px;
          border-bottom: 2px solid rgba(250, 204, 21, 0.85);
          border-right: 2px solid rgba(250, 204, 21, 0.85);
          border-radius: 0 0 4px 0;
        }

        .why-choose-us-experience-badge {
          position: absolute;
          left: 20px;
          bottom: 20px;
          z-index: 3;
          background: rgba(255, 255, 255, 0.97);
          color: #0f172a;
          padding: 10px 18px;
          border-radius: 12px;
          display: inline-flex;
          flex-direction: column;
          align-items: flex-start;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
        }

        .experience-number {
          font-size: 1.6rem;
          font-weight: 800;
          line-height: 1;
          color: #d4a017;
        }

        .experience-text {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.4px;
          text-transform: uppercase;
          margin-top: 3px;
          color: #475569;
        }

        /* ================= Right: compact card grid ================= */
        .why-choose-us-cards-section {
          flex: 1;
          width: 100%;
          display: flex;
        }

        .why-choose-us-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 14px;
          width: 100%;
          align-content: center;
        }

        .why-choose-us-card {
          border-radius: 12px;
          padding: 16px 14px;
          color: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          position: relative;
          overflow: hidden;
        }

        .why-choose-us-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 22px rgba(0, 0, 0, 0.2);
        }

        .why-choose-us-card-icon {
          width: 34px;
          height: 34px;
          min-width: 34px;
          border-radius: 9px;
          background: rgba(255, 255, 255, 0.22);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
        }

        .why-choose-us-card-content {
          display: flex;
          flex-direction: column;
        }

        .why-choose-us-card-title {
          font-size: 0.85rem;
          font-weight: 700;
          margin: 0 0 4px 0;
          line-height: 1.3;
        }

        .why-choose-us-card-text {
          font-size: 0.72rem;
          line-height: 1.45;
          opacity: 0.92;
          margin: 0;
        }

        /* ================= Responsive ================= */
        @media (max-width: 1024px) {
          .why-choose-us-content {
            flex-direction: column;
            gap: 32px;
          }

          .why-choose-us-image-section,
          .why-choose-us-cards-section {
            width: 100%;
            max-width: 720px;
            margin: 0 auto;
          }

          .why-choose-us-image-wrapper {
            min-height: 300px;
            aspect-ratio: 16 / 9;
          }
        }

        @media (max-width: 768px) {
          .why-choose-us-container {
            padding: 40px 15px;
          }

          .why-choose-us-title {
            font-size: 2.1rem;
          }

          .why-choose-us-subtitle {
            font-size: 0.98rem;
            padding: 0 15px;
          }

          .why-choose-us-header {
            margin-bottom: 28px;
          }
        }

        @media (max-width: 480px) {
          .why-choose-us-container {
            padding: 32px 10px;
          }

          .why-choose-us-title {
            font-size: 1.8rem;
            margin-bottom: 10px;
          }

          .why-choose-us-subtitle {
            font-size: 0.92rem;
            padding: 0 6px;
          }

          .why-choose-us-header {
            margin-bottom: 24px;
          }

          .why-choose-us-image-wrapper {
            min-height: 220px;
          }

          .why-choose-us-experience-badge {
            left: 14px;
            bottom: 14px;
            padding: 8px 14px;
          }

          .experience-number {
            font-size: 1.3rem;
          }

          .experience-text {
            font-size: 0.62rem;
          }

          .why-choose-us-grid {
            gap: 10px;
          }

          .why-choose-us-card {
            padding: 13px 11px;
          }

          .why-choose-us-card-icon {
            width: 30px;
            height: 30px;
            min-width: 30px;
            margin-bottom: 8px;
          }

          .why-choose-us-card-title {
            font-size: 0.78rem;
          }

          .why-choose-us-card-text {
            font-size: 0.68rem;
          }
        }

        /* Very small phones — drop to a single column so text never gets cramped */
        @media (max-width: 360px) {
          .why-choose-us-grid {
            grid-template-columns: 1fr;
          }

          .why-choose-us-title {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  );
};

export default WhyChooseUs;